import { Box, ButtonAppearance, ButtonSize, Text } from '@bechtel/gds';
import { useToolOrderCatalogStats } from '~/hooks';
import { ToolOrderCatalogItem } from '~/views/reservations/types';
import { ClearButtonStyled } from './styled';

interface CartHeaderProps {
  toolOrderCatalogItems: ToolOrderCatalogItem[];
  onClearCart: () => void;
}

export const CartHeader = ({ toolOrderCatalogItems, onClearCart }: CartHeaderProps) => {
  const toolCartStats = useToolOrderCatalogStats(toolOrderCatalogItems);

  return (
    <>
      <Box flexDirection={{ sm: 'column' }} gap={{ sm: '300' }}>
        <Text size="400" weight="600" color="grey.1000">
          Your Reservation
        </Text>
        <Box gap={{ sm: '300' }}>
          {toolCartStats &&
            Object.values(toolCartStats[1])?.map((toolTypes: any) => (
              <Box key={toolTypes.toolTypeName}>
                <Text size="300" color="grey.1000">
                  {/* {toolTypes.quantity} {toolTypes.toolTypeName} */}
                  {toolTypes.quantity} Item{toolTypes.quantity > 1 && 's'}
                </Text>
              </Box>
            ))}
          {!toolCartStats[0] && (
            <Text size="300" color="grey.1000">
              0 Items
            </Text>
          )}
        </Box>
      </Box>
      <Box>
        <ClearButtonStyled appearance={ButtonAppearance.TERTIARY} size={ButtonSize.SMALL}>
          <Text color="grey.600" onClick={onClearCart}>
            Clear Cart
          </Text>
        </ClearButtonStyled>
      </Box>
    </>
  );
};
